import React from "react";
import { SelecaoConvenio } from "../components/SelecaoConvenio";
import { useAuth } from "../hooks/useAuth";

const Convenio = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return window.location.assign("/");
  }

  return <SelecaoConvenio />;
};

export default Convenio;
